export { BackService } from './back.service'
export { StorageService } from './storage.service'



// WEBPACK FOOTER //
// ./src/app/services/index.ts